/* eslint-disable indent */
import React, { useState, useEffect } from "react";
import { Table } from "antd";
import { serialNum } from "../../../utils";
// import { useNavigate } from "react-router";
import urls from "../../../api/urls";
import API from "../../../api";

import "./style.scss";
const ViewTrip = ({ handleStep = () => {} }) => {
  const [tripList, setTripList] = useState([]);
  const [loading, setLoading] = useState(false);
  const [currentPage,setCurrentPage] = useState(0);
  const [pageSize,setPageSize] = useState(10);
  // const navigate = useNavigate();
  const { GET_TRIP_LIST } = urls;
  const getTripList = async () => {
    setLoading(true);
    let response = await API.Api(GET_TRIP_LIST + "?pageNum="+currentPage+"&pageSize="+pageSize).getWithUserNPremiseHeader();
    if (response?.status) {
      setTripList(response?.response?.data);
      setPageSize(response?.response?.data?.length);
      setLoading(false);
    }
  };
  useEffect(() => {
    getTripList();
  }, []);

  const columns = [
    {
      title: "Sl No",
      align: "center",
      with: 10,
      render: (a, b, idx) => serialNum(5, currentPage, idx),
    },
    {
      title: "Trip ID",
      dataIndex: "tripId",
      key: "tripId",
      render: (text, record) => (
        <div>
          <a
            onClick={() => handleStep("1", record,getTripList)}
            // style={{ pointerEvents: "none" }}
          >
            {text || "------"}
          </a>
        </div>
      ),
    },
    {
      title: "Vehicle LCR Id",
      dataIndex: "vehicleLcrId",
      key: "vehicleLcrId",
      render: (text) => <div>{text || "------"}</div>,
    },
    {
      title: "Vehicle LCR Status",
      dataIndex: "vehicleLcrStatus",
      key: "vehicleLcrStatus",
      render: (text) => <div>{text || "------"}</div>,
    },
    {
      title: "Mode",
      dataIndex: "travelBy",
      key: "travelBy",
      render: (text) => <div>{text || "------"}</div>,
    },
    {
      title: "Vehicle Number",
      dataIndex: "vehicleNum",
      key: "vehicleNum",
      render: (text) => <div>{text || "------"}</div>,
    },
    {
      title: "Flight Number",
      dataIndex: "flightNum",
      key: "flightNum",
      render: (text) => <div>{text || "------"}</div>,
    },
    {
      title: "Created Date",
      dataIndex: "createDate",
      key: "createDate",
      render: (text) => <div>{text.replace(" ", "/") || "------"}</div>,
    },

    {
      title: "Trip Status",
      dataIndex: "status",
      key: "status",
      render: (text) => <div>{text || "------"}</div>,
    },
  ];
  const paginationHandle = (pagination)=>{
  setCurrentPage(pagination.current);
  };
  const itemRender = (_, type, originalElement) => {
    if (type === "prev") {
      return <a>Previous</a>;
    }
    if (type === "next") {
      return <a>Next</a>;
    }
    return (
      <div>
        <p>{originalElement} </p>
      </div>
    );
  };
  return (
    <div className=" bagging-shipment" style={{ padding: "0" }}>
      <div className="lcr-table-container">
        <Table 
        loading={loading} 
        columns={columns} 
        dataSource={tripList}   
        pagination={{
              pageSize: 10,
              total: tripList?.length,
              itemRender: itemRender,
            }}
        onChange={paginationHandle}     
        />
      </div>
    </div>
  );
};

export default ViewTrip;
